import "core-js/modules/es.array.index-of";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.trim";
import "/root/workspace/admin_admin-web_uLO7/node_modules/@vue/babel-preset-app/node_modules/core-js/modules/es.array.iterator.js";
import "/root/workspace/admin_admin-web_uLO7/node_modules/@vue/babel-preset-app/node_modules/core-js/modules/es.promise.js";
import "/root/workspace/admin_admin-web_uLO7/node_modules/@vue/babel-preset-app/node_modules/core-js/modules/es.object.assign.js";
import "/root/workspace/admin_admin-web_uLO7/node_modules/@vue/babel-preset-app/node_modules/core-js/modules/es.promise.finally.js";
// import Vue from 'vue'
import App from './App.vue'; // 引入bairun-admin前端初始化相关内容

import './core/gin-vue-admin'; // 引入封装的router

import router from '@/router/index';
import '@/permission';
import { store } from '@/store';
Vue.config.productionTip = false;
import { Common } from '@/utils/common';
import { auth } from '@/directive/auth';
import { mobile } from '@/directive/mobile'; // 按钮权限指令

auth(Vue);
mobile(Vue);
import NP from 'number-precision';

Number.prototype.toFixed = function (len) {
  var add = 0;
  var s = NP.strip(this) + '';
  var start = s.indexOf('.');

  if (start > 0) {
    var s1 = s.substr(start + len + 1, 1);
    var s2 = s.substr(0, start + len + 1);

    if (s1 != '') {
      if (s1 >= 5) {
        add = 1;
      }

      s2 = s2.replace('.', '');
      s2 = Number(s2) >= 0 ? Number(s2) + add : Number(s2) - add;
      s = s2 / Math.pow(10, len);
    }
  }

  return Number(s);
};

var token = Common.getQueryString('token').trim();

if (token !== '') {
  store.commit('user/setToken', token);
}

export default new Vue({
  render: function render(h) {
    return h(App);
  },
  router: router,
  store: store
}).$mount('#app');